export default __webpack_public_path__ + "static/media/4img.59a0bcae.png";